import React, { useRef, useState } from "react";
import { useHistory } from "react-router";
import ActionButtons from "../components/ActionButtons";
import Header from "../components/Header";
import Loader from "../components/Loader";
import { fields, LOCAL_STORAGE_KEY } from "../constants";
import { getDetailsApi } from "../utils/api";
import { mergeLookupDetails } from "../utils/lookupDetails";

const districtNameOptions = [
  { name: "EAST GARO HILLS" },
  { name: "EAST JAINTIA HILLS" },
  { name: "EAST KHASI HILLS" },
  { name: "EASTERN WEST KHASI HILLS" },
  { name: "NORTH GARO HILLS" },
  { name: "RI BHOI" },
  { name: "SOUTH GARO HILLS" },
  { name: "SOUTH WEST GARO HILLS" },
  { name: "SOUTH WEST KHASI HILLS" },
  { name: "WEST GARO HILLS" },
  { name: "WEST JAINTIA HILLS" },
  { name: "WEST KHASI HILLS" },
];

const checkPostNameOptions = [
  { name: "BYRNIHAT", district: "RI BHOI" },
  { name: "RATACHERRA", district: "EAST JAINTIA HILLS" },
  { name: "BAJENGDOBA", district: "NORTH GARO HILLS" },
  { name: "DAWKI", district: "WEST JAINTIA HILLS" },
  { name: "BORSAURA", district: "SOUTH WEST KHASI HILLS" },
];

const vehiclePermitTypeOptions = [
  { name: "TRANSPORT" },
  { name: "NON-TRANSPORT" }
];

const vehicleClassOptions = [
  { name: "OMNI BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "EDUCATIONAL INSTITUTION BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "MOTOR CAB", category: "TRANSPORT", type: "PASSENGER" },
  { name: "MAXI CAB", category: "TRANSPORT", type: "PASSENGER" },
  { name: "PRIVATE SERVICE VEHICLE", category: "TRANSPORT", type: "PASSENGER" },
  { name: "HEARSES", category: "TRANSPORT", type: "PASSENGER" },
  { name: "GOODS CARRIER", category: "TRANSPORT", type: "GOODS" },
  { name: "CASH VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "POWER TILLER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "DUMPER", category: "TRANSPORT", type: "GOODS" },
  { name: "MULTI-AXLED GOODS", category: "TRANSPORT", type: "GOODS" },
  { name: "TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "SEMI-TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "MODULAR HYDRAULIC TRAILER", category: "TRANSPORT", type: "GOODS" },
  { name: "AUXILIARY TRAILER", category: "TRANSPORT", type: "GOODS" },
  { name: "TRACTOR-TROLLEY (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "TRACTOR (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "CHASSIS OF VEHICLES", category: "TRANSPORT", type: "GOODS" },
  { name: "ARTICULATED VEHICLE", category: "TRANSPORT", type: "GOODS" },
  { name: "AMBULANCE", category: "TRANSPORT", type: "GOODS" },
  { name: "ANIMAL AMBULANCE", category: "TRANSPORT", type: "GOODS" },
  { name: "FIRE TENDERS", category: "TRANSPORT", type: "GOODS" },
  { name: "LIBRARY VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "X-RAY VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE WORKSHOP", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE CANTEEN", category: "TRANSPORT", type: "GOODS" },
  { name: "SNORKEL LADDERS", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE CLINIC", category: "TRANSPORT", type: "GOODS" },
  { name: "VEHICLE FITTED WITH RIG", category: "NON-TRANSPORT" },
  { name: "EARTH MOVING EQUIPMENT", category: "NON-TRANSPORT" },
  { name: "EXCAVATOR (NT)", category: "NON-TRANSPORT" },
  { name: "CRANE MOUNTED VEHICLE", category: "NON-TRANSPORT" },
  { name: "FORK LIFT", category: "NON-TRANSPORT" },
  { name: "VEHICLE FITTED WITH GENERATOR", category: "NON-TRANSPORT" },
  { name: "TREE TRIMMING VEHICLE", category: "NON-TRANSPORT" },
  { name: "CONSTRUCTION EQUIPMENT VEHICLE", category: "NON-TRANSPORT" },
  { name: "RECOVERY VEHICLE", category: "NON-TRANSPORT" },
  { name: "ROAD ROLLER", category: "NON-TRANSPORT" },
  { name: "TOWER WAGON", category: "NON-TRANSPORT" },
  { name: "BREAKDOWN VAN", category: "NON-TRANSPORT" },
  { name: "TOW TRUCK", category: "NON-TRANSPORT" },
  { name: "CAMPER VAN / TRAILER (PRIVATE USE)", category: "NON-TRANSPORT" },
  { name: "VEHICLE FITTED WITH COMPRESSOR", category: "NON-TRANSPORT" },
  { name: "ARMOURED / SPECIALISED VEHICLE", category: "NON-TRANSPORT" },
  { name: "QUADRICYCLE (PRIVATE)", category: "NON-TRANSPORT" },
  { name: "HARVESTER", category: "NON-TRANSPORT" },
  { name: "THREE WHEELER (PERSONAL)", category: "NON-TRANSPORT" },
  { name: "POWER TILLER", category: "NON-TRANSPORT" },
  { name: "TRAILER FOR PERSONAL USE", category: "NON-TRANSPORT" }
];

const passengerCategoryOptions = [
  { name: "LIGHT PASSENGER VEHICLE" },
  { name: "MEDIUM PASSENGER VEHICLE" },
  { name: "HEAVY PASSENGER VEHICLE" }
];

const goodsCategoryOptions = [
  { name: "LIGHT GOODS VEHICLE" },
  { name: "MEDIUM GOODS VEHICLE" },
  { name: "HEAVY GOODS VEHICLE" }
];

const nonTransportCategoryOptions = [
  { name: "LIGHT MOTOR VEHICLE" },
  { name: "MEDIUM MOTOR VEHICLE" },
  { name: "HEAVY MOTOR VEHICLE" }
];

const permitTypeOptions = [
  { name: "TEMPORARY PERMIT" },
  { name: "TOURIST PERMIT" },
  { name: "SPECIAL PERMIT" },
  { name: "NOT APPLICABLE" }
];

const serviceTypeOptions = [
  { name: "ORDINARY" },
  { name: "AIR CONDITIONED" },
  { name: "Goods Service" },
  { name: "NOT APPLICABLE" }
];

const taxModeOptions = [
  { name: "DAILY" },
  { name: "WEEKLY" },
  { name: "MONTHLY" },
  { name: "QUARTERLY" },
  { name: "HALF YEARLY" },
  { name: "YEARLY" }
];

const goodsNameOptions = [
  "AUTO",
  "BEEDI LEAVES",
  "BITUMEN",
  "BRAN",
  "CARS",
  "CASHEWNUTS",
  "CEMENT",
  "CEMENT SHEETS",
  "CHEMICALS",
  "COCONUTS",
  "CRACKERS",
  "COSMOTICS",
  "DRY CHILIES",
  "EDIBLE OIL",
  "EGGS",
  "FRUITS",
  "GINGER",
  "GRANITE",
  "GROUND NUTS",
  "HAZARDOUS",
  "HUSK",
  "IRON ORE",
  "JCB",
  "LIMESTONE",
  "MARBLE",
  "MILK",
  "NAPA SLABS",
  "NAPTA",
  "ONIONS",
  "OTHER",
  "PAPER",
  "PETROL PUMP EQUIPMENTS",
  "PIPES",
  "PRAWNS",
  "PVC TANKS",
  "QURTZ",
  "RICE",
  "RIVER SAND",
  "SAND",
  "SILICA SAND",
  "SPONGE IRON LUMPS",
  "STEEL",
  "SUBABUL",
  "TILES",
  "TIMBER",
  "TRACTORS",
  "TRUCKS",
  "VEGETABLES",
  "WHEAT",
  "WOOD",
];

const Meghalaya = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

  const state = "meghalaya";
  const stateKey = "meghalaya";
  const history = useHistory();

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: "",
    surChargeFee: "",
    userCharge: "",
    chassisNo: "",
    mobileNo: "",
    vehiclePermitType: "",
    seatingCapacityExcludingDriver: "",
    sleeperCap: "",
    borderBarrier: "",
    districtName: "",
    totalAmount: "",
    ownerName: "",
    fromState: "",
    vehicleClass: "",
    taxMode: "",
    taxFromDate: "",
    taxUptoDate: "",
    permitType: "",
    serviceType: "",
    grossVehicleWeight: "",
    unladenWeight: "",
    fitnessValidity: "",
    insuranceValidity: "",
    taxValidity: "",
    floorArea: "",
    infraCess: "",
    mvTax: "",
    cess: "",
    permitFee: "",
    permitEndoresment: "",
    routeOfTheJourney: "",
    purposeOfJourney: "",
    checkpostName: "",
    registrationType: "",
    puccValidity: "",
    permitAuthorizationValidity: "",
    permit: "",
    pushbackSeats: "",
    tipperBody: "",
    permitNo: "",
    saleAmount: "",
    permitValidity: "",
    ordinarySeats: "",
    issuingAuthority: "",
    goodsName: "",
    fuelType: "",
    vehicleCategory: "",
    greenTaxValidity: "",
    cessPaidDate: "",
    regnDate: "",
    cubicCap: "",
    permitCategory: "",
    driverName: "",
    dlNumber: "",
    dlValidUptoDate: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert("Please enter vehicle no.");
      return;
    }
    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const calculateTotal = () => {
    const mv = parseFloat(payLoad.mvTax) || 0;
    const uc = parseFloat(payLoad.userCharge) || 0;
    const pf = parseFloat(payLoad.permitFee) || 0;
    const sc = parseFloat(payLoad.surChargeFee) || 0;

    return mv + uc + pf + sc;
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }

    payLoad.totalAmount = calculateTotal();

    history.push("/select-payment", {
      formData: {
        ...payLoad,
        state,
      },
    });
  };
 
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setPayLoad((old) => {
      let updatedData = { ...old, [name]: value };
      if (name === "vehiclePermitType") {
        updatedData.vehicleClass = "";
        updatedData.vehicleCategory = "";
        if (value !== "TRANSPORT") {
          updatedData.permitFee = "";
        }
      }

      if (name === "vehicleClass") {
        updatedData.vehicleCategory = "";
      }

      return updatedData;
    });
  };

  const onResetHandler = () => {
    let p = {};
    Object.keys(payLoad).forEach((e) => {
      p[e] = "";
    });
    setPayLoad({ ...p });
  };

  if (!isLoggedIn.accessState.includes(fields.stateName[stateKey])) {
    return (
      <>
        <Header />
        <div className="container text-center mt-4 ">
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="text-center">
        <p className="login-heading mt-4">
          <b>BORDER TAX PAYMENT FOR ENTRY INTO</b> <span>{fields.stateName[stateKey]}</span>
        </p>
      </div>
      <div className="box box--main">
        <div className="box__heading--blue">Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className="service-type tax-details mt-4"
        >
          <div className="row">
            <div className="col-6">
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="vehicleNo"
                >
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex="1"
                  required
                  maxLength="10"
                  autoFocus
                  inputMode="text"
                  disabled={isLoading}
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className="form__input w-100"
                  type="text"
                  id="vehicleNo"
                  name="vehicleNo"
                />
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="chassisNo"
                    >
                      Chassis No.<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="2"
                      maxLength="19"
                      inputMode="text"
                      disabled={isLoading}
                      onChange={onChangeHandler}
                      value={payLoad.chassisNo}
                      className="form__input w-100"
                      type="text"
                      id="chassisNo"
                      name="chassisNo"
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="mobileNo"
                    >
                      Mobile No.<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="3"
                      disabled={isLoading}
                      value={payLoad.mobileNo}
                      onChange={onChangeHandler}
                      placeholder=""
                      className="form__input w-100"
                      type="text"
                      id="mobileNo"
                      inputMode="tel"
                      maxLength="10"
                      minLength="10"
                      name="mobileNo"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="districtName"
                    >
                      District Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="4"
                      value={payLoad.districtName}
                      onChange={onChangeHandler}
                      required
                      name="districtName"
                      id="districtName"
                    >
                      <option value="">--Select District--</option>
                      {districtNameOptions.map((dist) => {
                        return (
                          <option key={dist.name} value={dist.name}>
                            {dist.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="checkpostName"
                    >
                      Checkpost Name
                    </label>
                    <select
                      tabIndex="4"
                      value={payLoad.checkpostName}
                      onChange={onChangeHandler}
                      required
                      name="checkpostName"
                      id="checkpostName"
                    >
                      <option value="">--Select Checkpost Name--</option>
                      {payLoad.districtName && (
                        checkPostNameOptions.filter(e => e.district === payLoad.districtName).length > 0 
                        ? checkPostNameOptions.filter(e => e.district === payLoad.districtName).map((checkpost) => (
                            <option key={checkpost.name} value={checkpost.name}>
                              {checkpost.name}
                            </option>
                          ))
                        : <option value={payLoad.districtName}>{payLoad.districtName}</option>
                      )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehiclePermitType"
                    >
                      Vehicle Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex="4"
                      value={payLoad.vehiclePermitType}
                      onChange={onChangeHandler}
                      required
                      name="vehiclePermitType"
                      id="vehiclePermitType"
                    >
                      <option value="">--Select Vehicle Type--</option>
                      {vehiclePermitTypeOptions.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleClass"
                    >
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex="11"
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name="vehicleClass"
                      id="vehicleClass"
                    >
                      <option value="">--Select Vehicle Class--</option>
                     {payLoad.vehiclePermitType &&
                        vehicleClassOptions
                         .filter(v => v.category === payLoad.vehiclePermitType)
                         .map((type) => (
                           <option key={type.name} value={type.name}>
                            {type.name}
                           </option>
                         ))
                       }
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="goodsName"
                    >
                      Name of Goods<sup>*</sup>
                    </label>
<select
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.goodsName}
                      onChange={onChangeHandler}
                      name="goodsName"
                      id="goodsName"
                    >
                      <option value="">Select Name of Goods...</option>
                      {goodsNameOptions.map((name) => (
                        <option key={name} value={String(name).toUpperCase()}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="serviceType"
                    >
                      Service Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex="13"
                      required
                      disabled={isLoading}
                      value={payLoad.serviceType}
                      onChange={onChangeHandler}
                      name="serviceType"
                      id="serviceType"
                    >
                      <option value="">--Service Type--</option>
                      {serviceTypeOptions.map((dist) => {
                        return (
                          <option key={dist.name} value={dist.name}>
                            {dist.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="taxFromDate"
                    >
                      Tax From Date<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="taxFromDate"
                      name="taxFromDate"
                      onChange={onChangeHandler}
                      value={payLoad.taxFromDate}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="taxUptoDate"
                    >
                      Tax Upto Date<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="taxUptoDate"
                      name="taxUptoDate"
                      type="datetime-local"
                      value={payLoad.taxUptoDate}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="taxMode"
                >
                  Tax Mode<sup>*</sup>
                </label>
                <select
                  tabIndex="7"
                  required
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.taxMode}
                  name="taxMode"
                  id="taxMode"
                >
                  <option value="">--Select Tax Mode--</option>
                  {taxModeOptions.map((type) => {
                    return (
                      <option value={type.name} key={type.name}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-6">
              <div className="form__control text-left">
                <label className="form__label d-block w-100 text-left">
                  &nbsp;
                </label>
                {isLoading && <Loader className="loader__get-details" />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type="button"
                    onClick={getDetailsHandler}
                    className="box__button get-details"
                  >
                    <span className="glyphicon glyphicon-arrow-down mr-3"></span>
                    Get Details
                  </button>
                )}
              </div>
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="ownerName"
                >
                  Owner Name<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="9"
                  disabled={isLoading}
                  className="form__input w-100"
                  type="text"
                  id="ownerName"
                  inputMode="text"
                  name="ownerName"
                  onChange={onChangeHandler}
                  value={payLoad.ownerName}
                />
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="fromState"
                    >
                      From State<sup>*</sup>
                    </label>
<select
                      tabIndex="10"
                      disabled={isLoading}
                      required
                      value={payLoad.fromState}
                      onChange={onChangeHandler}
                      name="fromState"
                      id="fromState"
                    >
                      <option value="">--Select State--</option>
                      {fields.fromState.map((type) => {
                        return (
                          <option key={type.name} value={String(type.name).toUpperCase()}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="routeOfTheJourney"
                    >
                      Route
                    </label>
                    <input
                      inputMode="text"
                      disabled={isLoading}
                      onChange={onChangeHandler}
                      value={payLoad.routeOfTheJourney}
                      className="form__input w-100"
                      type="text"
                      id="routeOfTheJourney"
                      name="routeOfTheJourney"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleCategory"
                    >
                      Vehicle Category<sup>*</sup>
                    </label>
                    <select
                      tabIndex="10"
                      disabled={isLoading}
                      required
                      value={payLoad.vehicleCategory}
                      onChange={onChangeHandler}
                      name="vehicleCategory"
                      id="vehicleCategory"
                    >
                      <option value="">--Select Vehicle Category--</option>
                      {payLoad.vehiclePermitType === "TRANSPORT" &&
                       vehicleClassOptions.find(
                        v => v.name === payLoad.vehicleClass
                        )?.type === "PASSENGER" &&
                       passengerCategoryOptions.map((c) => (
                       <option key={c.name} value={c.name}>
                          {c.name}
                      </option>
                    ))}
                      {payLoad.vehiclePermitType === "TRANSPORT" &&
                       vehicleClassOptions.find(
                         v => v.name === payLoad.vehicleClass
                       )?.type === "GOODS" &&
                       goodsCategoryOptions.map((c) => (
                         <option key={c.name} value={c.name}>
                           {c.name}
                         </option>
                       ))}
                      {payLoad.vehiclePermitType === "NON-TRANSPORT" &&
                       nonTransportCategoryOptions.map((c) => (
                         <option key={c.name} value={c.name}>
                           {c.name}
                         </option>
                       ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="permitType"
                    >
                      Permit Type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.permitType}
                      onChange={onChangeHandler}
                      name="permitType"
                      id="permitType"
                    >
                      <option value="">--Select Permit Type--</option>
                      {permitTypeOptions.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              {payLoad.vehiclePermitType === "TRANSPORT" &&
               vehicleClassOptions.some(
                 v => v.name === payLoad.vehicleClass && v.type === "PASSENGER"
               ) ? (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="seatingCapacityExcludingDriver"
                      >
                        Seating Capacity(Including Driver)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.seatingCapacityExcludingDriver}
                        id="seatingCapacityExcludingDriver"
                        name="seatingCapacityExcludingDriver"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="sleeperCap"
                      >
                        Sleeper Capacity <sup>*</sup>
                      </label>
                      <input
                        tabIndex="6"
                        required
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        value={payLoad.sleeperCap}
                        className="form__input w-100"
                        type="number"
                        id="sleeperCap"
                        name="sleeperCap"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="grossVehicleWeight"
                      >
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.grossVehicleWeight}
                        id="grossVehicleWeight"
                        name="grossVehicleWeight"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="unladenWeight"
                      >
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.unladenWeight}
                        id="unladenWeight"
                        name="unladenWeight"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="permitValidity"
                    >
                      Permit validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="permitValidity"
                      name="permitValidity"
                      onChange={onChangeHandler}
                      value={payLoad.permitValidity}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="fitnessValidity"
                    >
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="fitnessValidity"
                      name="fitnessValidity"
                      type="date"
                      value={payLoad.fitnessValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="puccValidUpto"
                    >
                      PUCC Valid up to<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="puccValidity"
                      name="puccValidity"
                      type="date"
                      value={payLoad.puccValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="insuranceValidity"
                    >
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="insuranceValidity"
                      name="insuranceValidity"
                      onChange={onChangeHandler}
                      value={payLoad.insuranceValidity}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <table className="hr-table">
                <thead>
                  <tr>
                    <th className="hr-table-1">SI. No.</th>
                    <th className="hr-table-2">Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="">1</td>
                    <td className="pb-table-text">MV Tax</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.mvTax}
                          onChange={onChangeHandler}
                          name="mvTax"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td className="">2</td>
                    <td className="pb-table-text">Service/User Charge</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.userCharge}
                          onChange={onChangeHandler}
                          name="userCharge"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td className="">3</td>
                    <td className="pb-table-text">Permit Fee</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.permitFee}
                          onChange={onChangeHandler}
                          name="permitFee"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td className="">4</td>
                    <td className="pb-table-text">Tax Token Fee</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          disabled={isLoading}
                          value={payLoad.surChargeFee}
                          onChange={onChangeHandler}
                          name="surChargeFee"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="totalAmount"
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="18"
                  min="0"
                  disabled
                  value={calculateTotal()}
                  className="form__input w-100"
                  type="number"
                  id="totalAmount"
                  name="totalAmount"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <label className="form__label d-block w-100 text-left">
                &nbsp;
              </label>
              <ActionButtons
                tabIndex="19"
                isDisabled={isLoading}
                onReset={onResetHandler}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Meghalaya;
